// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebaseConfig: {
    apiKey: "AIzaSyAtzOdWswKTfVLiSAesJp1dGuSvapwPabQ",
    authDomain: "arw-ts1-9895b.firebaseapp.com",
    projectId: "arw-ts1-9895b",
    storageBucket: "arw-ts1-9895b.appspot.com",
    messagingSenderId: "1022388239458",
    appId: "1:1022388239458:web:5568bc0d79a0c1ed5e653b",
    measurementId: "G-55EWSRDX31"
  },


  production: true,
  api_base_url: 'https://api.arw-dev.avitium.de:443/api/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
